export const environment = {
  env: 'dev-origin',
  api_url: 'https://conversation-api-dev.leasehawk.com/api/v1/',
  idp_url: 'https://login-dev.leasehawk.com',
  agent_call_management_api_url: 'https://agentcallmanagement-api-dev.leasehawk.com',
  client_id: 'conversation-viewer',
};
